var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { MiniQuestionMixedScore } from './modules/MiniQuestionMixedScore';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { MiniQuestionRewardScore } from './modules/MiniQuestionRewardScore';
import { MiniQuestionPassState } from './modules/MiniQuestionPassState';
import { MiniQuestionGlobalQuestion } from './modules/MiniQuestionGlobalQuestion';
import { MiniQuestionGivenAnswers } from './modules/MiniQuestionGivenAnswers';
import { MiniQuestionEdit } from './modules/MiniQuestionEdit';
import { MiniQuestionBrandingScore } from './modules/MiniQuestionBrandingScore';
import { MiniQuestionSuccessionScore } from './modules/MiniQuestionSuccessionScore';
export class MiniQuestion {
    id;
    parent;
    constructor(id, parent) {
        makeObservable(this);
        this.id = id;
        this.parent = parent;
    }
    get topic() {
        return this.parent.topic;
    }
    get app() {
        return this.topic.app;
    }
    get micro() {
        return this.parent.microQuestions.find((micro) => micro.id === this.id);
    }
    get miniMixedScore() {
        return new MiniQuestionMixedScore(this);
    }
    get miniSuccessionScore() {
        return new MiniQuestionSuccessionScore(this);
    }
    get miniRewardScore() {
        return new MiniQuestionRewardScore(this);
    }
    get miniBrandingScore() {
        return new MiniQuestionBrandingScore(this);
    }
    get miniPassState() {
        return new MiniQuestionPassState(this);
    }
    get miniGlobalQuestion() {
        return new MiniQuestionGlobalQuestion(this);
    }
    get miniGivenAnswers() {
        return new MiniQuestionGivenAnswers(this);
    }
    get miniQuestionEdit() {
        return new MiniQuestionEdit(this);
    }
    /* Quick Access */
    get questionType() {
        return this.micro.questionType;
    }
    get subtopicName() {
        return this.micro.subtopicName;
    }
    get toFunnelAnswer() {
        return this.app.tray.trayTransform.funnelMiniQuestionToAnswer(this);
    }
    get scoringStore() {
        try {
            return JSON.parse(this.micro.scoringStore);
        }
        catch (e) { }
        return {};
    }
}
__decorate([
    computed.struct
], MiniQuestion.prototype, "micro", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniMixedScore", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniSuccessionScore", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniRewardScore", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniBrandingScore", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniPassState", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniGlobalQuestion", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniGivenAnswers", null);
__decorate([
    memoize
], MiniQuestion.prototype, "miniQuestionEdit", null);
__decorate([
    memoize
], MiniQuestion.prototype, "scoringStore", null);
